(function () {
    'use strict';

    angular.module("imApp").factory("p2ExportProcMenuService", ['$ihttp', function ($ihttp) {
        let service = {
            getMenu: function (parms) {
                return $ihttp.post({
                    method: 1891,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
